import { borderRadius, breakpoints, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const Container = styled.footer`
  display: grid;
  padding: 12px 16px;
  border-top: 1px solid var(--border-soft);
  align-items: center;

  grid-template-areas:
    'Logotype ActionGroup'
    'NoticeMsg NoticeMsg';
  grid-template-columns: auto;
  grid-template-rows: auto;
  gap: 12px;

  @media ${breakpoints.md} {
    padding: 12px 24px;
    grid-template-areas: 'Logotype NoticeMsg ActionGroup';
    grid-template-columns: 200px auto 200px;
  }
`;

export const Logotype = styled.div`
  grid-area: Logotype;
`;

export const ActionGroup = styled.div`
  grid-area: ActionGroup;
  justify-self: end;
`;

export const NoticeMsg = styled.div`
  grid-area: NoticeMsg;
  text-align: center;
`;

export const ExternalLink = styled.a`
  ${typographyV2.bodyXs};
  color: var(--text-primary);
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const QRContainer = styled.section`
  ${borderRadius.r3};
  padding: 16px 20px;
  background: var(--surface-inverse);
  position: fixed;
  max-width: 200px;
  right: 16px;
  bottom: 16px;
  border: 2px solid var(--border-soft);
`;

export const ScanText = styled.p`
  ${typographyV2.titleBase}
  color: var(--text-inverse);
  overflow-wrap: break-word;
  max-width: 160px;
  text-align: center;
`;
